import React from 'react';

import { Button, Modal } from '@attentive-platform/stem-ui';

const ResetConfirmationModal = ({ show, onClose, onConfirm }) => {
  return (
    <Modal
      show={show}
      heading='Reset Configuration'
      onClose={onClose}
      content={
        <div className='flex flex-col gap-2 m-3 w-[360px]'>
          <div className='text-sm'>Are you sure you want to reset the entire configuration?</div>
          <div className='flex justify-end gap-2 mt-4'>
            <Button size='medium' variant='outlined' onClick={onClose}>
              Cancel
            </Button>
            <Button color='primary' size='medium' onClick={onConfirm}>
              Reset
            </Button>
          </div>
        </div>
      }
    />
  );
};

export default ResetConfirmationModal;
